import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLinkedin = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.14557 17H3.24646V7.65236H6.14557V17ZM4.6947 6.37749C4.36108 6.37904 4.03449 6.28152 3.75623 6.09725C3.47797 5.91298 3.26054 5.65025 3.13143 5.34227C3.00232 5.03429 2.96734 4.6949 3.0309 4.36702C3.09446 4.03913 3.25371 3.73748 3.48852 3.50021C3.72333 3.26293 4.02314 3.10069 4.35005 3.034C4.67696 2.96732 5.01628 2.99917 5.3251 3.12555C5.63393 3.25192 5.89838 3.46714 6.08503 3.74398C6.27168 4.02083 6.37213 4.34686 6.37369 4.68086C6.37417 5.12826 6.19793 5.5577 5.8834 5.87552C5.56888 6.19335 5.14158 6.37379 4.6947 6.37749ZM17 17H14.107V12.45C14.107 11.3659 14.0851 9.97462 12.5993 9.97462C11.0916 9.97462 10.8609 11.1524 10.8609 12.3712V17H7.96178V7.65236H10.7429V8.92811H10.7831C11.0612 8.45157 11.4633 8.05951 11.9464 7.7937C12.4296 7.52789 12.9757 7.3983 13.5267 7.41874C16.4607 7.41874 17 9.35249 17 11.8655V17Z",
		fill: "#0D2976"
	})
});
export default SvgLinkedin;
